const _sortedSelectedFiltes = (filter) => {
  let filterCharacteristics = {};
  let filterCategories = {};
  let filterPrices = {};

  const functionSorted = function (object) {
    return Object
      .keys(object)
      .sort()
      .reduce(
        (obj, key) => {
          obj[key] = object[key];
          return obj;
        },
        {},
      );
  };

  Object.keys(filter).map((key) => {
    if (key === 'categories') {
      filterCategories[key] = filter[key];
    } else if (key === 'priceFrom' || key === 'priceTo') {
      filterPrices[key] = filter[key];
    } else {
      filterCharacteristics[key] = filter[key];
    }
  });

  Object.keys(filterCharacteristics).map((key) => {
    filterCharacteristics[key] = functionSorted(filterCharacteristics[key]);
  });
  Object.keys(filterCategories).map((key) => {
    filterCategories[key] = functionSorted(filterCategories[key]);
  });
  Object.keys(filterPrices).map((key) => {
    filterPrices[key] = functionSorted(filterPrices[key]);
  });

  filterCharacteristics = functionSorted(filterCharacteristics);
  filterCategories = functionSorted(filterCategories);
  filterPrices = functionSorted(filterPrices);

  return {
    ...filterCharacteristics,
    ...filterCategories,
    ...filterPrices,
  };
};
const _sortedSelectedFiltesString = (filters) => {
  let selectedFilters = {};
  if (filters) {
    filters.split('/').forEach((filter) => {
      const [s, variants] = filter.split('=');
      selectedFilters[s] = {};
      (variants || '').split(',').forEach((variant) => {
        const v = variant.trim();
        selectedFilters[s][v] = v;
      });
    });
  }

  selectedFilters = _sortedSelectedFiltes(selectedFilters);

  const updateFiltersRequest = [];
  Object.keys(selectedFilters || {}).map((variantSlug) => {
    const values = [];

    Object.keys(selectedFilters[variantSlug]).map((value) => {
      values.push(value);
    });

    updateFiltersRequest.push(`${variantSlug}=${values.join(',')}`);
  });

  return updateFiltersRequest.join('/');
};

export {
  _sortedSelectedFiltesString,
};
